import { render, staticRenderFns } from "./BoxNumber.vue?vue&type=template&id=4b64eb0b&scoped=true"
import script from "./BoxNumber.vue?vue&type=script&lang=js"
export * from "./BoxNumber.vue?vue&type=script&lang=js"
import style0 from "./BoxNumber.vue?vue&type=style&index=0&id=4b64eb0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b64eb0b",
  null
  
)

export default component.exports